export default __webpack_public_path__ + "static/media/Huawei Nova 7i.46a6df1d.png";